import React from 'react'
import {Link} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {setSessionToken} from 'Skelet/src/modules/fetch.action.js'
import {toggleDropdown} from 'Skelet/src/modules/functions.js'


class CoreRouteHeader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {dropdown_open:false, is_scrolling:false};

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('scroll', this.handleScroll);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if(this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({dropdown_open:false});
    }
  }

  handleScroll(e) {
    if(window.pageYOffset === 0) {
      this.setState({is_scrolling:false});
    } else {
      this.setState({is_scrolling:true});
    }
  }

  render() {
    return (
      <header className={this.state.is_scrolling ? "scrolling" : null}><div className="container">
        <div className="primary">
          <Link to="/" className="logo text">{this.props.config.app_id}</Link>
        </div>
        <div className="secondary">
          <nav className="navigation">
            <ol>
              <li className={"nav-item" + ((this.props.pathname === "/echo") ? " current" : "")}><Link to="/echo">Echo</Link></li>
              <li className={"nav-item" + ((this.props.pathname === "/") ? " current" : "")}><Link to="/">Notificaties</Link></li>
              <li className={"nav-item dropdown" + ((this.state.dropdown_open) ? " open" : "")} ref={this.setWrapperRef}>
                <Link to="/settings" className="btn dropdown-toggle" onClick={(e) => toggleDropdown(this, e)}>
                  <span>{this.props.account_data.firstname[0]}</span>
                </Link>
                <div className="dropdown-menu">
                  <div className="dropdown-caret">
                    <span className="caret-outer"></span>
                    <span className="caret-inner"></span>
                  </div>
                  <ul>
                    <li className="sub-item highlight">
                      <Link to="/settings" onClick={() => toggleDropdown(this)}><b>{this.props.account_data.firstname}</b><p>Instellingen</p></Link>
                    </li>
                    <li className="dropdown-divider"></li>
                    <li className="sub-item"><Link to="/" onClick={this.props.logOut}>Uitloggen</Link></li>
                  </ul>
                </div>
              </li>
            </ol>
          </nav>
        </div>
      </div></header>
    );
  }

}


function mapStateToProps(state) {
  let account_data = null;
  if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["token"] !== undefined) {
    account_data = state.apiData["login"]["data"];
  }
  return {
    account_data: account_data,
    pathname: state.router.location.pathname,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    logOut: () => {document.getElementById("main").scrollIntoView(true);return setSessionToken(null)},
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreRouteHeader)



// WEBPACK FOOTER //
// ./src/containers/route-containers/CoreRouteHeader.js